import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'Job/getPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'Job/Save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'Job/Delete',
    method: 'post',
    data,
  })
}
